import { createBasicSelector } from 'util/redux'
import { selectBooleanPreferenceByName } from './selectBooleanPreferenceByName'

export const selectCurrentUserPreferReassignTicketOnReply = createBasicSelector(
  state =>
    selectBooleanPreferenceByName(state, 'reassign_ticket_on_reply', true)
)
